import React from "react";

import {
  mdiAccountMultiple,
  mdiAntenna,
  mdiArrowRightBoldBoxOutline,
  mdiAutoFix,
  mdiBatteryHigh,
  mdiDatabaseImport,
  mdiFaceMan,
  mdiFamilyTree,
  mdiHomeSilo,
  mdiProgressWrench,
  mdiStore,
  mdiTelevisionBox,
  mdiTelevisionClassic,
  mdiTools,
  mdiVideoVintage,
} from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import Menu, { MENU_ICON_SIZE } from "./Menu";
import MenuItem from "./MenuItem";
import Sidebar from "./Sidebar";
import SubMenu from "./SubMenu";
import {
  ADMIN_USERS_ROUTE,
  BULKS_ROUTE,
  CASTINGS_ROUTE,
  ENCODING_PROFILES_ROUTE,
  ENCODINGS_ROUTE,
  EXTERNAL_CONTENTS_ROUTE,
  FAST_CHANNELS_ROUTE,
  FAST_CONTENTS_ROUTE,
  HOSTED_CONTENTS_ROUTE,
  INSIGHTS_ROUTE,
  LIVE_CONTENTS_ROUTE,
  ORGANIZATION_CONFIGURATION_ROUTE,
  PROJECTS_ROUTE,
} from "../routes/routes";

import type { JSX } from "react";

function MainMenu(): JSX.Element {
  const { t } = useTranslation("editor-menu");
  const renderNewIcon = (iconPath: string): JSX.Element => (
    <Icon path={iconPath} size={MENU_ICON_SIZE} />
  );

  return (
    <Sidebar id="sidebar-main-menu">
      <Menu>
        <SubMenu
          isDefaultOpen
          icon={renderNewIcon(mdiAutoFix)}
          label={t("publishMonetize")}
        >
          <MenuItem
            abilityList={["projects"]}
            component={<NavLink to={PROJECTS_ROUTE} />}
            icon={renderNewIcon(mdiStore)}
            label={t("projects")}
          />
          <MenuItem
            abilityList={["fastChannels"]}
            component={<NavLink to={FAST_CHANNELS_ROUTE} />}
            icon={renderNewIcon(mdiTelevisionBox)}
            label={t("fast_channels")}
          />
        </SubMenu>
        <SubMenu
          isDefaultOpen
          abilityList={["contents"]}
          icon={renderNewIcon(mdiVideoVintage)}
          label={t("catalog")}
        >
          <MenuItem
            component={<NavLink to={HOSTED_CONTENTS_ROUTE} />}
            icon={renderNewIcon(mdiHomeSilo)}
            label={t("contents_item")}
          />
          <MenuItem
            abilityList={["lives"]}
            component={<NavLink to={LIVE_CONTENTS_ROUTE} />}
            icon={renderNewIcon(mdiAntenna)}
            label={t("contents_live")}
          />
          <MenuItem
            abilityList={["ottContents"]}
            component={<NavLink to={FAST_CONTENTS_ROUTE} />}
            icon={renderNewIcon(mdiTelevisionClassic)}
            label={t("contents_fast")}
          />
          <MenuItem
            abilityList={["ottContents"]}
            component={<NavLink to={EXTERNAL_CONTENTS_ROUTE} />}
            icon={renderNewIcon(mdiArrowRightBoldBoxOutline)}
            label={t("contents_external")}
          />
          <MenuItem
            abilityList={["castings"]}
            component={<NavLink to={CASTINGS_ROUTE} />}
            icon={renderNewIcon(mdiFaceMan)}
            label={t("castings")}
          />
          <MenuItem
            abilityList={["bulks"]}
            component={<NavLink to={BULKS_ROUTE} />}
            icon={renderNewIcon(mdiDatabaseImport)}
            label={t("bulks")}
          />
          <MenuItem
            component={<NavLink to={ENCODINGS_ROUTE} />}
            icon={renderNewIcon(mdiProgressWrench)}
            label={t("encodings")}
          />
          <MenuItem
            component={<NavLink to={ENCODING_PROFILES_ROUTE} />}
            icon={renderNewIcon(mdiTools)}
            label={t("encodingProfiles")}
          />
        </SubMenu>
        <SubMenu
          isDefaultOpen
          abilityList={["insights", "adminUsers"]}
          icon={renderNewIcon(mdiFamilyTree)}
          label={t("myOrganization")}
        >
          <MenuItem
            abilityList={["insights"]}
            component={<NavLink to={INSIGHTS_ROUTE} />}
            icon={renderNewIcon(mdiBatteryHigh)}
            label={t("insights")}
          />
          <MenuItem
            abilityList={["adminUsers"]}
            component={<NavLink to={ADMIN_USERS_ROUTE} />}
            icon={renderNewIcon(mdiAccountMultiple)}
            label={t("publishers_management")}
          />
          <MenuItem
            abilityList={["adminUsers"]}
            component={<NavLink to={ORGANIZATION_CONFIGURATION_ROUTE} />}
            icon={renderNewIcon(mdiTools)}
            label={t("organizationConfiguration")}
          />
        </SubMenu>
      </Menu>
    </Sidebar>
  );
}

export default MainMenu;
